import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { SectionHeading } from "@/accounts-payable/common";
import type { ApVendorListEdit } from "@/accounts-payable/types";
import { EditableChips } from "./editable-chips";

export const ProductLookupsSection = ({
  domains,
  onEditList,
}: {
  domains: string[];
  onEditList: (edit: ApVendorListEdit) => void;
}) => (
  <Stack className="w-full" align="start" gap={2}>
    <SectionHeading>Product lookups</SectionHeading>
    <Text variant="caption" tone="muted">
      Pages the agent may read when enriching SKUs.
    </Text>
    <EditableChips
      values={domains}
      noun="domain"
      placeholder="vendor.com"
      onAdd={(value) =>
        onEditList({ field: "allowed_domains", action: "add", value })
      }
      onRemove={(value) =>
        onEditList({ field: "allowed_domains", action: "remove", value })
      }
    />
  </Stack>
);
